import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchSingleBracket, openPopup } from '../redux/app';

class TreeProvider extends React.Component {
  id = 0;

  componentDidUpdate(prevProps, prevState) {
    if (
      JSON.stringify(prevProps.defaultValues) !==
      JSON.stringify(this.props.defaultValues)
    ) {
      this.setState({
        values: this.mapProps(),
      });
    }

    if (
      prevState &&
      (prevState.values.player1 !== this.state.values.player1 ||
        prevState.values.player2 !== this.state.values.player2) &&
      this.state.values.winner !== this.state.values.player1 &&
      this.state.values.winner !== this.state.values.player2
    ) {
      this.setState({
        values: {
          ...this.state.values,
          winner: '',
        },
      });
    }
  }

  paramsChange = (params) => {
    if (params.id && params.id !== this.id) {
      this.id = params.id;
      this.props.loadBracket(this.id);
    }
  };

  routeRender = (renderFN) => (routeProps) => {
    const { params } = routeProps.match;

    this.paramsChange(params);

    if (params.nodeId) {
    }
    return renderFN(routeProps);
  };

  createPath = (path) => `${this.props.url}${path}`;

  render() {
    return this.props.children.map((children, i) =>
      React.cloneElement(children, {
        key: i,
        component: undefined,
        render: this.routeRender(
          this.props.renderFunction(children.props.component)
        ),
        path: Array.isArray(children.props.path)
          ? children.props.path.map(this.createPath)
          : this.createPath(children.props.path),
      })
    );
  }
}

TreeProvider.propTypes = {
  children: PropTypes.any,
  loadBracket: PropTypes.func,
  url: PropTypes.string,
  renderFunction: PropTypes.func,
  defaultValues: PropTypes.object,
};

const mapDispatchToProps = (dispatch) => ({
  loadBracket: (id) => dispatch(fetchSingleBracket(id)),
  openPopup: (props) => dispatch(openPopup(props)),
});

export default connect(undefined, mapDispatchToProps)(TreeProvider);
